<template>
  <div class="container">
    <div class="nav-con">
      <div class="nav con-wd">
        <div class="logo" @click="$router.push('/Home')"></div>
        <div class="menu">
          <template
            v-if="
              !activeRouteMatch.includes('/manage/newdoc/:id?') && !activeRouteMatch.includes('/manage/selecttype/:id?')
            "
          >
            <div v-for="menu of menuList" :key="menu.id">
              <div
                :class="[
                  $route.path === menu.path ? 'active' : '',
                  menu.purview === '客户中心' && $route.path === '/manage/detailsTalk' ? 'active' : '',
                  menu.purview === '项目中心' && $route.path === '/manage/doclist' ? 'active' : '',
                ]"
                @click="go(menu)"
              >
                {{ menu.purview }}
              </div>
            </div>
            <div class="blank"></div>
          </template>
          <template v-else>
            <div class="blank">
              <span :class="[activeRouteMatch.includes('/manage/newdoc/:id?') ? 'active' : '']">1、选择模块</span>
              <i :style="{ margin: '0 32px', color: 'rgba(0,0,0,0.2500)' }" class="el-icon-arrow-right"></i>
              <span :class="[activeRouteMatch.includes('/manage/selecttype/:id?') ? 'active' : '']">
                2、业态类型&梯种
              </span>
            </div>
          </template>

          <div class="head">
            <template
              v-if="
                !activeRouteMatch.includes('/manage/newdoc/:id?') &&
                !activeRouteMatch.includes('/manage/selecttype/:id?')
              "
            >
              <div @click="getTaskList" style="position: relative">
                <div v-show="show" class="point"></div>
                <img
                  style="width: 20px; vertical-align: bottom; margin-top: 1px"
                  src="../../assets/imgs/icon_task@2x.png"
                />
              </div>
              <div class="arrow">
                <el-dropdown>
                  <span class="username">
                    {{ userList.name }}
                    <i style="margin-left: 2px" class="el-icon-caret-bottom" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <button @click="getUserManage" class="but">个人信息</button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <div>
                        <div class="text_push" v-if="show_weekPush"></div>
                        <button @click="getWeeklyPush" class="but">每周推送</button>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <button @click="getOut" class="but">退出登录</button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template v-else>
              <div class="close" @click="back">
                <i class="el-icon-circle-close"></i>
                关闭
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!--个人信息-->
    <el-dialog :visible.sync="dialogUser" width="500px" style="width: 90%; margin: 0 auto" title="个人信息">
      <el-form :model="userList" label-position="right" label-width="100px">
        <el-form-item label="账号">
          <el-input disabled v-model="userList.qwUserId" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-input disabled v-model="userList.companyName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input disabled v-model="userList.name" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
<!--    每周推送-->
    <el-dialog
      :visible.sync="dialogWeek"
      title="每周推送"
      width="20%"
      class="weekpush"
    >
      <div style="font-size: 16px">
        <p>您上周登陆了 <span class="text_color">{{loginNum}}</span> 次</p>
        <p>共创建了 <span class="text_color">{{createNum}}</span> 个项目，发布了 <span class="text_color">{{publishNum}}</span> 篇文档</p>
        <p>浏览了 <span class="text_color">{{readNum}}</span> 篇文档</p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialog"
      width="80%"
      style="width: 90%; margin: 0 auto"
      title="任务列表"
      :before-close="close"
    >
      <el-table
        :data="taskList"
        :header-cell-style="{ textAlign: 'center', background: '#EBE9E9', color: '#000000', fontsize: '16px' }"
        :cell-style="{ textAlign: 'center', color: 'rgba(0,0,0,0.85)', fontsize: '14px' }"
      >
        <el-table-column label="客户名称" prop="buyerName" width="350"></el-table-column>
        <el-table-column label="项目名称" prop="projectName" width="200"></el-table-column>
        <el-table-column label="所属省市" prop="city" width="200"></el-table-column>
        <el-table-column label="项目号" prop="businessNum" width="170"></el-table-column>
        <el-table-column label="创建时间" width="170">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatter }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: center">
              <el-button pain type="text" @click="goDialog(scope.$index)" style="width: 60px">关联项目</el-button>
              <el-button pain type="text" @click="goProject(scope.$index)" style="width: 60px">创建项目</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandleHis"
        @current-change="currentChangeHandleHis"
        :current-page.sync="pageNum"
        :page-sizes="[5, 20, 50, 100]"
        :page-size.sync="pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="text-align: right; padding-bottom: 20px; margin: 25px 50px"
      ></el-pagination>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" title="项目列表" width="70%">
      <div>
        <el-table
          :data="assignmentList"
          :header-cell-style="{ textAlign: 'center', background: '#EBE9E9', color: '#000000', fontsize: '16px' }"
          :cell-style="{ textAlign: 'center', color: 'rgba(0,0,0,0.85)', fontsize: '14px' }"
        >
<!--          <el-table-column label="封面">-->
<!--            <template slot-scope="scope">-->
<!--              <img-->
<!--                v-if="scope.row.coverUrl"-->
<!--                :src="scope.row.coverUrl"-->
<!--                style="width: 140px; height: 80px; border: none"-->
<!--              />-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="客户名称" prop="customerName" width="220"></el-table-column>
          <el-table-column label="项目名称" prop="projectName"></el-table-column>
          <el-table-column label="省市">
            <template slot-scope="scope">{{ scope.row.province }}{{ scope.row.city }}</template>
          </el-table-column>
          <el-table-column label="商机号" prop="quote"></el-table-column>
          <el-table-column label="创建时间" width="170">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormatter }}
            </template>
          </el-table-column>
          <el-table-column width="230" label="操作">
            <template slot-scope="scope">
              <el-button pain type="text" @click="goRelevance(scope.$index)">关联项目</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="sizeChangeHandleHisTask"
          @current-change="currentChangeHandleHisTask"
          :current-page.sync="pageNumTask"
          :page-sizes="[5, 20, 50, 100]"
          :page-size.sync="pageSizeTask"
          :total="totalTask"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right; padding-bottom: 20px; margin: 25px 50px"
        ></el-pagination>
      </div>
    </el-dialog>
    <router-view v-if="hasGetMenu"></router-view>

  </div>
</template>

<script>
import Assignment from "@/components/pc/Assignment";
import { removeToken } from "@/utils/auth";
import { mapMutations, mapState } from "vuex";
import moment from "moment";
import {weekPushList, getweekPushList} from '@/api/weekPush'
export default {
  name: "layout",
  data() {
    return {
      userList: {},
      centerDialogVisible: false,
      dialog: false,
      taskList: [],
      pageNum: 1,
      pageSize: 5,
      total: 0,
      show: false,
      assignmentList: [],
      pageNumTask: 1,
      pageSizeTask: 5,
      totalTask: 0,
      dialogVisible: false,
      menuList: [],
      dialogUser: false,
      hasGetMenu: false,
      dialogWeek: false,
      show_weekPush: null,
      loginNum: 0, //登录次数
      createNum: 0, //创建项目数
      publishNum: 0, //发布文档数
      readNum: 0 //浏览文档数
    };
  },
  computed: {
    ...mapState(["menuStatus"]),
    ...mapMutations(["changeTaskId"]),
    ...mapMutations(["changeProjectId"]),
    activeRouteMatch() {
      return this.$route.matched.map(item => item.path);
    },
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format("YYYY-MM-DD HH:mm");
    },
  },
  methods: {
    // 每周推送
    weeklyPush() {
      weekPushList().then(res => {
        this.show_weekPush = res.data
      })
    },
    getWeeklyPush() {
      getweekPushList().then(res => {
        this.dialogWeek = true
        this.loginNum = res.data.loginNum //登录次数
        this.createNum = res.data.createNum //创建项目数
        this.publishNum = res.data.publishNum //发布文档数
        this.readNum = res.data.loginNum //浏览文档数
        this.weeklyPush()
      })
    },
    getUserManage() {
      this.dialogUser = true;
    },
    getList() {
      this.$request.projectList(this.pageNumTask, this.pageSizeTask).then(res => {
        console.log(res, "任务列表");
        this.assignmentList = res.data.records;
        this.totalTask = res.data.total;
      });
    },
    goRelevance(index) {
      const data = {
        taskId: this.$store.state.taskId, //任务id
        projectId: this.$store.state.projectId, //后台导入项目id
        businessOpportunityId: this.assignmentList[index].id, //前台商机项目id
      };
      this.$request.getRelevance([data]).then(res => {
        this.$message.success("关联成功");
        this.dialogVisible = false;
        this.getList();
        this.taskProject();
      });
    },
    sizeChangeHandleHisTask() {
      this.getList();
    },
    // 当前页
    currentChangeHandleHisTask() {
      this.getList();
    },
    close() {
      this.dialog = false;
      localStorage.setItem("dialog", "false");
    },
    back() {
      this.$router.go(-1);
    },
    go(menu) {
      this.$router.push(menu.path);
    },
    goProject(index) {
      this.dialog = false;
      this.$router.push({
        path: "/manage/newproject",
        query: { projectId: this.taskList[index].projectId, taskId: this.taskList[index].taskId },
      });
    },
    goDialog(index) {
      this.$store.commit("changeTaskId", { value: this.taskList[index].taskId });
      this.$store.commit("changeProjectId", { value: this.taskList[index].projectId });
      this.dialogVisible = true;
    },
    CloseUp() {
      this.centerDialogVisible = false;
      this.from.Oldpwd = "";
      this.from.password = "";
      this.from.pwd = "";
    },
    // 获取用户的信息
    getuser() {
      this.$store
        .dispatch("user/getInfo")
        .then(res => {
          this.userList = res;
          console.log(this.userList, "用户信息");
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 退出登录
    getOut() {
      this.$request
        .getOut()
        .then(res => {
          if (res.code === 200) {
            this.$message.success("退出登录成功");
            localStorage.removeItem("code");
            localStorage.removeItem("lxState");
            this.$router.push("/login");
            localStorage.removeItem("UserAdmin");
            window.location.reload();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTaskList() {
      this.dialog = true;
      this.taskProject();
    },
    taskProject() {
      this.$request.taskList(this.pageNum, this.pageSize).then(res => {
        this.taskList = res.data.records;
        this.total = res.data.total;
        if (this.taskList.length) {
          this.show = true;
        }
      });
    },
    getUserMenu() {
      this.$store.dispatch("user/getMenu").then(res => {
        this.menuList = res.menuList;
        const hasPermissionPaths = res.hasPermissionPaths;
        if (!hasPermissionPaths.length) {
          this.$router.replace("/manage/noPermission");
        }
        if (
          (hasPermissionPaths.length &&
            res.allPaths.includes(this.$route.path) &&
            !hasPermissionPaths.includes(this.$route.path)) ||
          (hasPermissionPaths.length && this.$route.path === "/manage/noPermission")
        ) {
          this.$router.replace(hasPermissionPaths[0]);
        }
        setTimeout(() => {
          this.hasGetMenu = true;
        }, 50);
      });
    },
    sizeChangeHandleHis() {
      this.taskProject();
    },
    // 当前页
    currentChangeHandleHis() {
      this.taskProject();
    },
  },
  created() {
    this.getUserMenu();
  },
  mounted() {
    if (localStorage.getItem("dialog") == "true" && this.taskList.length) {
      this.dialog = true;
    }
    this.taskProject();
    this.getuser();
    this.getList();
    this.weeklyPush()
  },
};
</script>
<style scoped lang="less">
.weekpush{
  //::v-deep .el-dialog .el-dialog__header{
  //  text-align: center !important;
  //}
  ::v-deep .el-dialog .el-dialog__body{
    display: flex;
    justify-content: center;
  }
}
</style>
<style lang="less">
.text_color{
   color: #e60027;
 }
.text_push{
  width: 5px;
  height: 5px;
  float: right;
  background-color: red;
  border-radius: 2.5px;
  margin-top: 5px;
}
.point {
  width: 6px;
  height: 6px;
  background-color: red;
  border-radius: 4px;
  position: absolute;
  left: 14px;
  top: -2px;
}
.avatar-wrapper {
  margin-top: 5px;
  position: relative;
  min-width: 46px;
  display: flex;
  justify-content: flex-start;
  .user-avatar {
    cursor: pointer;
    width: 50px;
    height: 50px;
    border-radius: 25px;
  }

  .el-icon-caret-bottom {
    cursor: pointer;
  }
}

.container {
  // display: none;
  & > .nav-con {
    background-color: #fff;
    // visibility: hidden;
    //margin-bottom: 20px;
    box-shadow: 0px 2px 2px 1px rgba(0, 0, 0, 0.04);

    & > .nav {
      width: 1504px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      align-items: center;

      & > .logo {
        flex: 0 0 117px;
        height: 42px;
        cursor: pointer;
        background: url("~@/assets/imgs/menu_logo@2x.png") no-repeat center center / 100% auto;
      }

      & > .menu {
        padding-left: 80px;
        flex: 1;
        display: flex;
        align-items: center;

        & > div {
          flex: 0 0 auto;
          padding: 0 32px;
          cursor: pointer;
          font-size: 16px;
          font-weight: bold;
        }

        & > .blank {
          flex: 1;
          text-align: center;
        }

        & > .head {
          flex: 0 0 60px;
          display: flex;
          align-items: center;
          .username {
            display: inline-block;
            font-size: 14px;
            white-space: nowrap;
            padding: 2px;
            margin-left: 4px;
          }
          & > .img {
            flex: 0 0 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 20px;
            background-color: #ffd8bf;
            color: #e60027;
          }

          & > .arrow {
            flex: 0 0 20px;
            height: 20px;
            // background: url('~@/assets/imgs/icon_arrow_down@2x.png') no-repeat center center / 100% auto;
          }

          & > .close {
            color: #e60027;
          }
        }

        & .active {
          color: #e60027;
        }
      }
    }
  }

  .con-wd {
    width: 1100px;
    margin: 24px auto 0px;
    background-color: #fff;
    //padding: 0 20px;
    & > .container {
      border-top: 1px solid rgba(0, 0, 0, 0.06);
      min-height: 640px;
      padding-top: 36px;

      & .left {
        padding-left: 130px;
      }

      & .right {
        border-left: 1px solid #f0f0f0;
        padding-left: 32px;
      }

      & > .boot {
        text-align: right;
        width: 860px;
        margin: 0 auto;
        padding: 16px 0;
        border-top: 1px solid rgba(0, 0, 0, 0.06);
        margin-top: 20px;
      }
    }
  }
}

.but {
  border: none;
  background-color: white;
  color: #6666fc;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
::v-deep .el-form-item__error {
  padding-top: 3px !important;
  font-size: 10px !important;
  margin-left: 130px !important;
}

::v-deep .el-form-item > .el-form-item__label {
  font-size: 16px !important;
}

::v-deep .el-descriptions-item__label {
  color: rgba(0, 0, 0, 0.85);
}
</style>
